// extracted by mini-css-extract-plugin
export var copyIcon = "_y5-2";
export var discountCard = "_y5-0";
export var discountCode = "_y5-3";
export var discountContent = "_y5-1";
export var loadingCard = "_y5-4";